'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Created by Andrey Gayvoronsky on 13/04/16.
 */
var locale = {
  placeholder: 'Выберите время'
};

exports['default'] = locale;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ant-design-vue/lib/time-picker/locale/ru_RU.js
// module id = VfLb
// module chunks = 0